(function (angular) {
	'use strict';

	angular
		.module('PinMeTo.services')
		.service('pmtSideBarCollapsedService', function ($window, localStorageService) {
			const self = this;

			function get() {
				return !!localStorageService.get('sidebarCollapsed');
			}

			function set(collapsed) {
				localStorageService.set('sidebarCollapsed', collapsed);
			}

			self.get = get;
			self.set = set;
		});
})(window.angular);
